"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = require("../../../theme/styled");

var CardContent = styled_1["default"]('div')({}, function (props) {
  return {
    color: props.theme.colors.text,
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: "" + (props.noPadding ? 0 : props.theme.card.padding)
  };
});
exports["default"] = CardContent;